// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5245":"991ec794","5348":"d0ad0f92"}[chunkId] + ".chunk.css";
};